import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-big_img_mode",
  "use": "icon-big_img_mode-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" class=\"svg-icon\" id=\"icon-big_img_mode\"><path d=\"M2.025 11.775v-3.25H.4v3.25A1.63 1.63 0 0 0 2.025 13.4h3.25v-1.625zM11.775.4h-3.25v1.625h3.25v3.25H13.4v-3.25A1.63 1.63 0 0 0 11.775.4m-9.75 1.625h3.25V.4h-3.25A1.63 1.63 0 0 0 .4 2.025v3.25h1.625zm9.75 9.75h-3.25V13.4h3.25a1.63 1.63 0 0 0 1.625-1.625v-3.25h-1.625z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol